import { app } from '../../bootstrap/core';

app.config(function (formControlProvider, validationRulesProvider) {
  'ngInject';

  const { TEXT, IBAN } = formControlProvider.controlTypes;

  // NOTE: Actual that's a little hack to change the type of
  // text controls with 'iban' validation to type 'iban'.
  formControlProvider.setTypeModifier(TEXT, (type, control) => {
    if (control.options && control.options.validate && control.options.toggleIbanDisplayMode) {
      const { validate } = control.options;
      if (type === TEXT && validate === IBAN) {
        return IBAN;
      }
    }
    return type;
  });

  // Activate the toggle between 'iban' and 'bcan' display mode
  // which defaults to 'iban'.
  formControlProvider.setTypeOptions(IBAN, {
    ibanDisplayMode: 'iban',
    toggleIbanDisplayMode: true
  });

  // Add or overwrite any validation rule
  // validationRulesProvider.addRule('fax', /^[0-9\-\+\s\(\)]*$/);
});
